import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2459514a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guide-container" }
const _hoisted_2 = { class: "guide-body" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "분실물 안내",
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }),
    _createElementVNode("div", _hoisted_2, [
      ($setup.lostAndFoundGuideUrl)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            class: "layout",
            src: $setup.lostAndFoundGuideUrl
          }, null, 8 /* PROPS */, _hoisted_3))
        : (_openBlock(), _createBlock($setup["EmptyContent"], {
            key: 1,
            text: "분실물 안내가 없습니다."
          }))
    ])
  ]))
}